import React from 'react';
import { Styles } from './styles';

export function LayoutContentList({ children }) {
    return <Styles data-e2e='dp_promotionList'>{children}</Styles>;
}
